import { APIConfig } from "../auth/AuthorizeService";
import {
    AlarmsService,
    ApiPanelsService,
    AppConfigurationService,
    AssetControlService,
    AssetEditorService,
    AssetsInformationService,
    ChatService,
    DocumentationService,
    ForgeService,
    HeatmapService,
    IdentityService,
    NotificationsService,
    PowerAppsService,
    PowerBIService,
    ProjectsService,
    ReboteService,
    RuleSetsService,
    SignalsService,
    UserAzureService,
    UserInformationService,
    UserPermitsService,
} from "./APIClient";

export const forgeService = new ForgeService(APIConfig);
export const identityService = new IdentityService(APIConfig);
export const projectsService = new ProjectsService(APIConfig);
export const documentationService = new DocumentationService(APIConfig);
export const assetsInformationService = new AssetsInformationService(APIConfig);
export const notificationsService = new NotificationsService(APIConfig);
export const powerBIService = new PowerBIService(APIConfig);
export const ruleSetsService = new RuleSetsService(APIConfig);
export const apiPanelsService = new ApiPanelsService(APIConfig);
export const powerAppsService = new PowerAppsService(APIConfig);
export const assetControlService = new AssetControlService(APIConfig);
export const alarmsService = new AlarmsService(APIConfig);
export const reboteService = new ReboteService(APIConfig);
export const userAzureService = new UserAzureService(APIConfig);
export const assetEditorService = new AssetEditorService(APIConfig);
export const userInformationService = new UserInformationService(APIConfig);
export const chatService = new ChatService(APIConfig);
export const appConfigurationService = new AppConfigurationService(APIConfig);
export const userPermitsService = new UserPermitsService(APIConfig);
export const heatmapService = new HeatmapService(APIConfig);
export const signalService = new SignalsService(APIConfig);
